var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagJapan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3125 3.75H4.6875C2.61643 3.75 0.9375 5.42893 0.9375 7.5V22.5C0.9375 24.5711 2.61643 26.25 4.6875 26.25H25.3125C27.3836 26.25 29.0625 24.5711 29.0625 22.5V7.5C29.0625 5.42893 27.3836 3.75 25.3125 3.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M25.3125 3.75H4.6875C2.61656 3.75 0.9375 5.42906 0.9375 7.5V22.5C0.9375 24.5709 2.61656 26.25 4.6875 26.25H25.3125C27.3834 26.25 29.0625 24.5709 29.0625 22.5V7.5C29.0625 5.42906 27.3834 3.75 25.3125 3.75ZM28.125 22.5C28.125 24.0506 26.8631 25.3125 25.3125 25.3125H4.6875C3.13687 25.3125 1.875 24.0506 1.875 22.5V7.5C1.875 5.94937 3.13687 4.6875 4.6875 4.6875H25.3125C26.8631 4.6875 28.125 5.94937 28.125 7.5V22.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.625C18.1066 20.625 20.625 18.1066 20.625 15C20.625 11.8934 18.1066 9.375 15 9.375C11.8934 9.375 9.375 11.8934 9.375 15C9.375 18.1066 11.8934 20.625 15 20.625Z",
    fill: "#AE232F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.3125 4.6875H4.6875C3.13406 4.6875 1.875 5.94656 1.875 7.5V8.4375C1.875 6.88406 3.13406 5.625 4.6875 5.625H25.3125C26.8659 5.625 28.125 6.88406 28.125 8.4375V7.5C28.125 5.94656 26.8659 4.6875 25.3125 4.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagJapan);
export default __webpack_public_path__ + "static/media/flag_japan.1d9d522f7dc08b7b112dc288ede39153.svg";
export { ForwardRef as ReactComponent };